"use client"

import { Discount } from "@/lib/redux/features/store/type"
import { Col, Row, theme } from "antd"
import { useEffect, useRef, useState } from "react"
import dayjs from 'dayjs'
import Text from "@/components/common/Typography/Text"
import { TextProps } from "antd/es/typography/Text"

const PromoDuration = ({ discount, type, textType, onEnded }: { discount: Discount, type?: 'ghost' | 'full', textType?: TextProps['type'], onEnded: () => void }) => {
  const now = dayjs()
  const endDate = dayjs(discount.end_date)

  const intervel = useRef<any>(null)
  const refInitDuration = useRef<any>(false)

  const token = theme.useToken().token
  const [duration, setDuration] = useState(endDate.diff(now, 'second'))

  if (!refInitDuration.current) {
    const initDuration = endDate.diff(now, 'second')
    setDuration(initDuration)
    refInitDuration.current = true
  }

  useEffect(() => {
    if (intervel.current) {
      clearInterval(intervel.current)
      intervel.current = null
    }
    intervel.current = setInterval(() => {
      const now = dayjs()
      const endDate = dayjs(discount.end_date)
      const newDuration = endDate.diff(now, 'second')
      if (newDuration <= 0) {
        onEnded()
      }
      setDuration(newDuration <= 0 ? 0 : newDuration)
    }, 1000)
  }, [discount.end_date, onEnded])

  const days = Math.floor(duration / 86400)
  const hours = Math.floor((duration - (days * 86400)) / 3600)
  const minutes = Math.floor((duration - (days * 86400) - (hours * 3600)) / 60)
  const seconds = duration - (days * 86400) - (hours * 3600) - (minutes * 60)

  const labels = ['D', 'H', 'M', 'S']
  const labelsFull = ['Days', 'Hours', 'Mins', 'Secs']
  const values = [days, hours, minutes, seconds]

  const isFull = type === 'full'

  return (
    <Row wrap={false} align='middle' style={{ marginInline: type === 'ghost' ? '-0.5rem' : '-0.25rem' }}>
      {values.map((val, idx) => {
        if (!val && !values[idx - 1]) return;
        return (
          <Col style={{ paddingInline: type === 'ghost' ? '0.3rem' : '0.25rem' }}>
            <Row
              style={type === 'ghost' ? {

              } : {
                backgroundColor: token.colorWhite,
                borderRadius: token.borderRadius,
                paddingInline: '0.7rem',
                paddingBlock: '0.5rem',
                minWidth: isFull ? '4rem' : '5rem',
                width: isFull ? '5rem' : 'auto'
              }}
              justify='center'
              wrap={isFull}
              align='bottom'
            >
              <Col span={isFull ? 24 : undefined}>
                <Text type={textType} strong style={{ width: '2.03rem', lineHeight: '1.8rem', wordBreak: 'keep-all', whiteSpace: 'nowrap', ...(isFull ? { width: '100%', textAlign: 'center', display: 'block' } : {}) }}>{val < 10 ? `0${val}` : val}</Text>
              </Col>
              <Col span={isFull ? 24 : undefined}>
                <Text type={textType} style={{ fontSize: '1.2rem', marginLeft: '0.2rem', ...(isFull ? { width: '100%', textAlign: 'center', display: 'block' } : {}) }}>{(isFull ? labelsFull : labels)[idx]}</Text>
              </Col>
            </Row>
          </Col>
        )
      })}
    </Row>
  )
}

export default PromoDuration